import React, { useEffect } from "react";
import { Prompt } from 'react-router-dom';
export var FormPrompt = function FormPrompt(_ref) {
  var hasUnsavedChanges = _ref.hasUnsavedChanges,
      formPromptMessage = _ref.formPromptMessage;
  useEffect(function () {
    var onBeforeUnload = function onBeforeUnload(e) {
      if (hasUnsavedChanges) {
        e.preventDefault();
        e.returnValue = "";
      }
    };

    window.addEventListener("beforeunload", onBeforeUnload);
    return function () {
      return window.removeEventListener("beforeunload", onBeforeUnload);
    };
  }, [hasUnsavedChanges]);

  var onLocationChange = function onLocationChange(location) {
    return formPromptMessage;
  };

  return /*#__PURE__*/React.createElement(Prompt, {
    when: hasUnsavedChanges,
    message: onLocationChange
  });
};